import { useStyles } from '@webapps/styles';
import ModalFullScreenWithoutAction from 'components/ModalFullScreenWithoutAction/ModalFullScreenWithoutAction';
import { useEffect, useState } from 'react';
import { getOodriveDocument } from '@webapps/business';
import { useMutation, useToast } from '@webapps/reactjs-tech-components';
import { Button, CardContent } from '@material-ui/core';
import { RouterRounded } from '@material-ui/icons';

const DocumentCard = ({ document, opcoRecord, refetch }) => {
  const { classes, css, cx, global } = useStyles(styles);

  const [open, setOpen] = useState(false);
  const [fileUrl, setFileUrl] = useState(null);
  const { addToast } = useToast();

  const {
    data,
    error,
    isLoading,
    isSuccess,
    mutateAsync: getOodriveDocumentMutateAsync,
  } = useMutation(getOodriveDocument);

  useEffect(() => {
    if (isSuccess) {
      const url = URL.createObjectURL(data);
      setFileUrl(url);
    } else if (error) {
      addToast({
        status: 'error',
        message: 'Une erreur est survenue lors de la récupération du document.',
      });
      setOpen(false);
    }

  }, [isSuccess, error]);

  return (
    <div className={classes.container}>
      <CardContent className={css({ paddingBottom: 20 })}>
        <div className={cx(global.infoText, classes.address)}>
          <RouterRounded className={global.infoIcon} />
          <div>{`Type de document : ${document?.type}`}</div>
        </div>
      </CardContent>
      <div className={classes.buttons}>
        <Button
          onClick={() => {setOpen(true), getOodriveDocumentMutateAsync({ id: opcoRecord.id, type: document.type })}}
          className={global.greyButton}
          variant="outlined"
        >
          Voir les détails
        </Button>
      </div>
      <ModalFullScreenWithoutAction
        onCancel={() => setOpen(false)}
        open={open}
        title="Mes documents"
      >
        <iframe
          className={css({ width: '100%', height: '100%' })}
          frameBorder="0"
          src={fileUrl}
          title="Fichier"
        />
      </ModalFullScreenWithoutAction>
    </div>
  );
};

const styles = ({ fontSizes, spacing }) => ({
  gap: {
    gap: 40,
  }
});

export default DocumentCard;